__turbopack_context__.v({
  "account-svg": "T3LvyG_account-svg",
  "dropdown": "T3LvyG_dropdown",
  "dropdownWrapper": "T3LvyG_dropdownWrapper",
  "flex": "T3LvyG_flex",
  "flex-quiz": "T3LvyG_flex-quiz",
  "has-subnav": "T3LvyG_has-subnav",
  "hover": "T3LvyG_hover",
  "link-text": "T3LvyG_link-text",
  "main-nav-container": "T3LvyG_main-nav-container",
  "master-nav-ul": "T3LvyG_master-nav-ul",
  "minus-icon": "T3LvyG_minus-icon",
  "nav-item-link": "T3LvyG_nav-item-link",
  "nav-list-item": "T3LvyG_nav-list-item",
  "nav-switcher-flex": "T3LvyG_nav-switcher-flex",
  "plus-icon": "T3LvyG_plus-icon",
  "products": "T3LvyG_products",
  "results": "T3LvyG_results",
  "science": "T3LvyG_science",
});
